import { render, staticRenderFns } from "./ListInventory.vue?vue&type=template&id=1bfbb8e2&scoped=true&"
import script from "./ListInventory.vue?vue&type=script&lang=js&"
export * from "./ListInventory.vue?vue&type=script&lang=js&"
import style0 from "./ListInventory.vue?vue&type=style&index=0&id=1bfbb8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfbb8e2",
  null
  
)

export default component.exports